import React from "react"

import SmsAction from "./SmsAction";
import CallAction from "./CallAction";
import Call800Action from "./Call800Action";
import PinAction from "./PinAction";
import MobileIdAction from "./MobileIdAction";
import VoipAction from "./VoipAction";
import ExtraActionAuth from "./ExtraAction";

// блок отрисовки форм для действий пользователей при авторизации.
// Нужно передавать функцию для переключения статуса авторизации устройства
// функции возврата из формы
// true\false значения по нужному методу. Не допускать одновременного наличия true\false флагов для нескольких методов.
// для external action, нужно передавать полный конфиг выбранного юнита(настройки).
// todo: для оптимизации, возможно следует передавать сюда нужный компонент отрисовки через hoc
const ButtonsAction = (props) => {
    // console.log(props.external, props.extraBtnShow)
    return (
        <>
            {
                props.extraBtnShow && 
                <ExtraActionAuth
                    handlerBackBtn={props.handlerBackBtn}
                    setAccess={props.setAccess}
                    external={props.external}
                />
            }
            {
                props.smsBtnShow && <SmsAction
                    handlerBackBtn={props.handlerBackBtn}
                    setAccess={props.setAccess}
                />
            }
            {
                props.pinBtnShow && <PinAction
                    handlerBackBtn={props.handlerBackBtn}
                    setAccess={props.setAccess}
                />
            }
            {
                props.midBtnShow && <MobileIdAction
                    handlerBackBtn={props.handlerBackBtn}
                    setAccess={props.setAccess}
                />
            }
            {
                props.call800BtnShow && <Call800Action
                    handlerBackBtn={props.handlerBackBtn}
                    setAccess={props.setAccess}
                />
            }
            {
                props.callBtnShow && <CallAction
                    handlerBackBtn={props.handlerBackBtn}
                    setAccess={props.setAccess}
                />
            }
            {
                props.voipBtnShow && <VoipAction
                    handlerBackBtn={props.handlerBackBtn}
                    setAccess={props.setAccess}
                />
            }
        </>
    )
}

export default ButtonsAction